import(/* webpackMode: "eager", webpackExports: ["CommonErrorPage"] */ "/home/mraof/.cache/yay/hedgedoc2/src/hedgedoc-2.0.0-alpha.3/frontend/src/components/error-pages/common-error-page.tsx");
